<app-modal
  [title]="'Ticket details'| trans:'ticket-details-modal/header/title'"
  maxWidth="500px"
  [compact]="true"
>
  <ng-template>
    @if (isLoading()) {
      <div class="d-flex justify-content-center full-height align-items-center">
        <app-loader size="lg" />
      </div>
    } @else if (ticket) {
      <table class="base full-width wrap">
        <tbody>
        <tr>
          <td colspan="2">
            <div>
              {{ ticket.ticketDescription }}
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <div>
              {{ 'Suchbegriff'| trans:'tickets-search/table/ticket-details-modal/table/searchTerm.Label' }}
            </div>
          </td>
          <td>
            <div>
              {{ ticket.searchTerm }}
            </div>
          </td>
        </tr>

          <tr>
            <td>
              <div>
                {{ 'Preis:' | trans:'ticket-details-modal/table/priceDescription.Label' }}
              </div>
            </td>
            <td>
              <div>
                {{ ticket.priceDescription }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div>
                {{ 'Ticketnummber:' | trans:'ticket-details-modal/table/ticketNr.Label' }}
              </div>
            </td>
            <td>
              <div>
                {{ ticket.allTicketNrs?.length ? ticket.allTicketNrs.join(', ') : ticket.ticketNr }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div>
                {{ 'VdF-Nummer:' | trans:'ticket-details-modal/table/vdfNumber.Label' }}
              </div>
            </td>
            <td>
              <div>
                {{ ticket.ticketCinemaNumber }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div>
                {{ 'Ticketstatus:' | trans:'ticket-details-modal/table/status.Label' }}
              </div>
            </td>
            <td>
              <div>
                {{ ticket.status }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div>
                {{ 'Bemerkung:' | trans:'ticket-details-modal/table/cancelInfo.Label' }}
              </div>
            </td>
            <td>
              <div>
                {{ ticket.cancelInfo }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div>
                {{ 'Ticketpreis:' | trans:'ticket-details-modal/table/amount.Label' }}
              </div>
            </td>
            <td>
              @if (ticket.packagePrice) {
                <div class="d-flex flex-direction-column gap-8">
                  <div class="d-flex justify-content-space-between gap-16">
                    <span>{{ 'Package' | trans:'ticket-details-modal/table/packagePrice.Label' }}</span>
                    <span>{{ ticket.packagePrice | numberToCurrency }} {{ languageConfig.currency.short }}</span>
                  </div>
                  <div class="d-flex justify-content-space-between gap-16">
                    <span>{{ 'Ticket' | trans:'ticket-details-modal/table/ticketPrice.Label' }}</span>
                    <span>{{ ticket.ticketPrice | numberToCurrency }} {{ languageConfig.currency.short }}</span>
                  </div>
                  <div class="d-flex justify-content-space-between gap-16">
                    <span>{{ 'Total' | trans:'ticket-details-modal/table/totalPrice.Label' }}</span>
                    <span>{{ ticket.amount | numberToCurrency }} {{ languageConfig.currency.short }}</span>
                  </div>
                </div>
              } @else {
                <div>
                  {{ ticket.amount | numberToCurrency }} {{ languageConfig.currency.short }}
                </div>
              }
            </td>
          </tr>

          <tr>
            <td>
              <div>
                {{ 'Product package:' | trans:'ticket-details-modal/table/packageName.Label' }}
              </div>
            </td>
            <td>
              <div>
                {{ ticket.packageName || '-' }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div>
                {{ 'Statushistorie:' | trans:'ticket-details-modal/table/history.Label' }}
              </div>
            </td>
            <td>
              <div class="d-flex flex-direction-column gap-8">
                @for (history of ticket.history; track history.actionDate) {
                  <div>
                    {{ history.actionDate | localeDatetimeFormat }} {{ history.type }} -> {{ history.status }} ({{ history.employee }})
                  </div>
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <p class="m-t-16">
        {{ 'Do you want to print this information?' | trans:'ticket-details-modal/doYouWantToPrintInformation.Text' }}
      </p>
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'No'| trans:'ticket-details-modal/no.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="isReportGenerating()"
        (click)="printTicketDetails()"
      >
        {{ 'Yes'| trans:'ticket-details-modal/yes.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-pdf-viewer-modal #pdfViewerModalComponent />
